"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var e={};exports.__exports=e;
//# sourceMappingURL=react-is.development2.js.map
